import { Howl } from "howler";

export class Sound {
    value: Howl
}